export type SegmentKind = 'text' | 'field' | 'link' | 'unknown' | 'misplaced' | 'stray';

export interface Segment {
  text: string;
  kind: SegmentKind;
}

const TOKEN = /\{\{[^{}]+\}\}/g;
const STRAY = /\{\{|\}\}/g;

/**
 * Zerlegt einen Text für die Hervorhebung. Was ein Feld an dieser Stelle ist, weiß nur der
 * Aufrufer — Nachrichten und Anfahrt kennen verschiedene Felder und Regeln.
 */
export function splitTokens(value: string, classify: (token: string) => SegmentKind): Segment[] {
  const result: Segment[] = [];
  let last = 0;
  for (const match of value.matchAll(TOKEN)) {
    pushText(result, value.slice(last, match.index));
    result.push({ text: match[0], kind: classify(match[0]) });
    last = match.index + match[0].length;
  }
  pushText(result, value.slice(last));
  return result;
}

/** Klammern ohne Gegenstück sind eigene Stücke — so sieht man, wo ein Feld unvollständig ist. */
function pushText(result: Segment[], text: string) {
  let last = 0;
  for (const match of text.matchAll(STRAY)) {
    if (match.index > last) result.push({ text: text.slice(last, match.index), kind: 'text' });
    result.push({ text: match[0], kind: 'stray' });
    last = match.index + match[0].length;
  }
  if (last < text.length) result.push({ text: text.slice(last), kind: 'text' });
}
